export default {
    routerName: '公告新增',
    routerNamePic: '图片裁剪',
    announce: {
        name: '公告名',
        thumb: '缩略图',
        image: '图片',
        scope: '范围',
        scope0: '前台',
        scope1: '后台',
        scope2: '前后台',
        level: '重要度',
        level0: '普通',
        level1: '正常',
        level2: '重要',
        startTime: '开始时间',
        endTime: '结束时间',
        status: '状态',
        open: '启用',
        close: '禁用',
        description: '描述',
    },
};
